"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mutate;

var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));

var _flatten2 = _interopRequireDefault(require("lodash/flatten"));

var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));

var _chunk2 = _interopRequireDefault(require("lodash/chunk"));

var _debug = _interopRequireDefault(require("debug"));

var _query = require("./query");

var _profiling = _interopRequireDefault(require("./profiling"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var info = (0, _debug.default)('rrf:mutate');

var docRef = function docRef(firestore, collection, doc) {
  return firestore.doc("".concat(collection, "/").concat(doc));
};

function promiseAllObject(_x) {
  return _promiseAllObject.apply(this, arguments);
}

function _promiseAllObject() {
  _promiseAllObject = _asyncToGenerator(regeneratorRuntime.mark(function _callee(object) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = Object;
            _context.next = 3;
            return Promise.all(Object.entries(object).map(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                  key = _ref2[0],
                  promise = _ref2[1];

              return promise.then(function (value) {
                return [key, value];
              });
            }));

          case 3:
            _context.t1 = _context.sent;
            return _context.abrupt("return", _context.t0.fromEntries.call(_context.t0, _context.t1));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _promiseAllObject.apply(this, arguments);
}

function isBatchedWrite(operations) {
  return Array.isArray(operations);
}

function isDocRead(read) {
  return read && typeof read.doc === 'string';
}

function isSingleWrite(operations) {
  return operations && typeof operations.collection === 'string';
}

var primaryValue = function primaryValue(arr) {
  return Array.isArray(arr) && typeof arr[0] === 'string' && arr[0].indexOf('::') === 0 ? null : arr;
};

var arrayUnion = function arrayUnion(firebase, key) {
  var _firebase$firestore$F;

  if (key !== '::arrayUnion') return null;

  for (var _len = arguments.length, val = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    val[_key - 2] = arguments[_key];
  }

  return (_firebase$firestore$F = firebase.firestore.FieldValue).arrayUnion.apply(_firebase$firestore$F, val);
};

var arrayRemove = function arrayRemove(firebase, key) {
  var _firebase$firestore$F2;

  if (key !== '::arrayRemove') return null;

  for (var _len2 = arguments.length, val = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    val[_key2 - 2] = arguments[_key2];
  }

  return (_firebase$firestore$F2 = firebase.firestore.FieldValue).arrayRemove.apply(_firebase$firestore$F2, val);
};

var increment = function increment(firebase, key, val) {
  return key === '::increment' && typeof val === 'number' && firebase.firestore.FieldValue.increment(val);
};

var serverTimestamp = function serverTimestamp(firebase, key) {
  return key === '::serverTimestamp' && firebase.firestore.FieldValue.serverTimestamp();
};

function atomize(firebase, operation) {
  var requiresUpdate = false;
  return [Object.keys(operation).reduce(function (data, key) {
    var clone = _objectSpread({}, data);

    var val = clone[key];

    if (key.includes('.')) {
      requiresUpdate = true;
    }

    if (!val) return clone;
    var value = primaryValue(val) || serverTimestamp(firebase, val[0]) || arrayUnion(firebase, val[0], val[1]) || arrayRemove(firebase, val[0], val[1]) || increment(firebase, val[0], val[1]);

    if (Array.isArray(val) && val.length > 0) {
      clone[key] = value;
    }

    return clone;
  }, (0, _cloneDeep2.default)(operation)), requiresUpdate];
}

function write(firebase) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var writer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var collection = operation.collection,
      path = operation.path,
      doc = operation.doc,
      id = operation.id,
      data = operation.data,
      rest = _objectWithoutProperties(operation, ["collection", "path", "doc", "id", "data"]);

  var ref = docRef(firebase.firestore(), path || collection, id || doc);

  var _atomize = atomize(firebase, data || rest),
      _atomize2 = _slicedToArray(_atomize, 2),
      changes = _atomize2[0],
      _atomize2$ = _atomize2[1],
      requiresUpdate = _atomize2$ === void 0 ? false : _atomize2$;

  if (writer) {
    var writeType = writer.commit ? 'Batching' : 'Transaction.set';
    info(writeType, _objectSpread({
      id: ref.id,
      path: ref.parent.path
    }, changes));

    if (requiresUpdate) {
      writer.update(ref, changes);
    } else {
      writer.set(ref, changes, {
        merge: true
      });
    }

    return _objectSpread({
      id: ref.id,
      path: ref.parent.path
    }, changes);
  }

  info('Writing', _objectSpread({
    id: ref.id,
    path: ref.parent.path
  }, changes));

  if (requiresUpdate) {
    return ref.update(changes);
  }

  return ref.set(changes, {
    merge: true
  });
}

function writeSingle(firebase, operations) {
  var done = (0, _profiling.default)('mutate.writeSingle');
  var promise = write(firebase, operations);
  done();
  return promise;
}

var MAX_BATCH_COUNT = 500;

function writeInBatch(_x2, _x3) {
  return _writeInBatch.apply(this, arguments);
}

function _writeInBatch() {
  _writeInBatch = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(firebase, operations) {
    var done, committedBatchesPromised;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            done = (0, _profiling.default)('mutate.writeInBatch');
            committedBatchesPromised = (0, _chunk2.default)(operations, MAX_BATCH_COUNT).map(function (operationsChunk) {
              var batch = firebase.firestore().batch();
              var writesBatched = operationsChunk.map(function (operation) {
                return write(firebase, operation, batch);
              });
              return batch.commit().then(function () {
                return writesBatched;
              });
            });
            done();
            return _context2.abrupt("return", Promise.all(committedBatchesPromised).then(_flatten2.default));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _writeInBatch.apply(this, arguments);
}

function writeInTransaction(_x4, _x5) {
  return _writeInTransaction.apply(this, arguments);
}

function _writeInTransaction() {
  _writeInTransaction = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(firebase, operations) {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", firebase.firestore().runTransaction(function () {
              var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(transaction) {
                var serialize, getter, done, readsPromised, reads, writes;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        serialize = function serialize(doc) {
                          return !doc ? null : _objectSpread(_objectSpread({}, doc.data()), {}, {
                            id: doc.ref.id,
                            path: doc.ref.parent.path
                          });
                        };

                        getter = function getter(ref) {
                          info('Transaction.get ', {
                            id: ref.id,
                            path: ref.parent.path
                          });
                          return transaction.get(ref);
                        };

                        done = (0, _profiling.default)('mutate.writeInTransaction:reads');
                        readsPromised = (0, _mapValues2.default)(operations.reads, function () {
                          var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(read) {
                            var doc, _snapshot, coll, snapshot, unserializedDocs;

                            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                              while (1) {
                                switch (_context3.prev = _context3.next) {
                                  case 0:
                                    if (!isDocRead(read)) {
                                      _context3.next = 6;
                                      break;
                                    }

                                    doc = (0, _query.firestoreRef)(firebase, read);
                                    _context3.next = 4;
                                    return getter(doc);

                                  case 4:
                                    _snapshot = _context3.sent;
                                    return _context3.abrupt("return", serialize(_snapshot.exsits === false ? null : _snapshot));

                                  case 6:
                                    coll = (0, _query.firestoreRef)(firebase, read);
                                    _context3.next = 9;
                                    return coll.get();

                                  case 9:
                                    snapshot = _context3.sent;

                                    if (!(snapshot.docs.length === 0)) {
                                      _context3.next = 12;
                                      break;
                                    }

                                    return _context3.abrupt("return", []);

                                  case 12:
                                    _context3.next = 14;
                                    return Promise.all(snapshot.docs.map(getter));

                                  case 14:
                                    unserializedDocs = _context3.sent;
                                    return _context3.abrupt("return", unserializedDocs.map(serialize));

                                  case 16:
                                  case "end":
                                    return _context3.stop();
                                }
                              }
                            }, _callee3);
                          }));

                          return function (_x7) {
                            return _ref4.apply(this, arguments);
                          };
                        }());
                        done();
                        _context4.next = 7;
                        return promiseAllObject(readsPromised);

                      case 7:
                        reads = _context4.sent;
                        writes = [];
                        operations.writes.forEach(function (writeFnc) {
                          var complete = (0, _profiling.default)('mutate.writeInTransaction:writes');
                          var operation = typeof writeFnc === 'function' ? writeFnc(reads) : writeFnc;

                          if (Array.isArray(operation)) {
                            operation.map(function (op) {
                              return write(firebase, op, transaction);
                            });
                            writes.push(operation);
                          } else {
                            writes.push(write(firebase, operation, transaction));
                          }

                          complete();
                        });
                        return _context4.abrupt("return", {
                          reads: reads,
                          writes: writes
                        });

                      case 11:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              }));

              return function (_x6) {
                return _ref3.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _writeInTransaction.apply(this, arguments);
}

function mutate(firestore, operations) {
  if (isSingleWrite(operations)) {
    return writeSingle(firestore, operations);
  }

  if (isBatchedWrite(operations)) {
    return writeInBatch(firestore, operations);
  }

  return writeInTransaction(firestore, operations).then(function (val) {
    return val;
  });
}